import { useEffect, useState } from "react";
import axios from "axios";
import initial from "../generated/offer-config.json";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const eur = (n) => `${n.toLocaleString("fr-FR")}\u00a0€`;

export function useOfferConfig() {
  const [cfg, setCfg] = useState(initial);
  useEffect(() => {
    axios.get(`${API}/offer-config`).then((r) => {
      if (JSON.stringify(r.data) !== JSON.stringify(initial)) {
        console.warn("offer-config.json is out of date: run scripts/export_offer_config.py");
        setCfg(r.data);
      }
    }).catch(() => {});
  }, []);
  return cfg;
}
